package org.vreo.devicehub.features.core.domain.device.videoCameraConfig

/**
 * Video configuration. Represents video configuration.
 */
data class VideoConfig(
    // Basic video config
    val resolution: CameraResolution = CameraResolution.FOUR_K,
    val frameRotation: VideoFrameRotation = VideoFrameRotation.ROTATE_0,

    // Exposure and brightness control
    val targetBrightness: Float = 0.0f,
    val maxExposureTimeUs: Float = 0.0f,
    val minExposureTimeUs: Float = 0.0f,
    val maxGain: Float = 0.0f,
    val minGain: Float = 0.0f,

    // Zoom and focus
    val zoom: Float = 0.0f,
    val focus: Float = 0.0f,
    val zoomMini: Float? = null,
    val zoomMax: Float? = null,
    val focusMini: Float? = null,
    val focusMax: Float? = null,
)